const ARABIC_RE =
    /[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

export const arabicRatio = (s = "") => {
    const chars = [...s].filter((c) => c.trim().length > 0);
    if (!chars.length) return 0;
    const a = chars.filter((c) => ARABIC_RE.test(c)).length;
    return a / chars.length;
};

export const getTitleFromRaw = (raw = "", fallback = "Tazkirah") => {
    const line = raw.split(/\r?\n/).find((l) => l.trim());
    return (line || fallback).trim();
};

export const getExcerptFromRaw = (raw = "") => {
    const paras = raw
        .split(/\n\s*\n/g)
        .map(p => p.trim())
        .filter(Boolean);

    if (!paras.length) return "";

    // Jika baris pertama adalah tajuk, ambil perenggan seterusnya
    const first = paras[0];
    const second = paras[1];

    if (first.length < 80 && second) {
        return second;
    }

    return first;
};


export const parseBlocks = (raw = "") => {
    const paras = raw
        .split(/\n\s*\n/g)
        .map((p) => p.trim())
        .filter(Boolean);

    return paras.map((text) => ({
        text,
        isArabic: arabicRatio(text) > 0.3,
    }));
};
